import { LoginLayout, DefaultLayout } from '@/layouts';

export const publicRoute = [
  {
    path: '*',  
    name: 'notFound',  
    component: () => import(/* webpackChunkName: "NotFound" */'@/views/errors/NotFound.vue')
  },
  {
    path: '/',
    component: LoginLayout,
    redirect: "/login",
    hidden: true,
    children: [
      {
        path: '/login',
        name: 'Login',
        meta: { title: 'Login' },
        component: () => import(/* webpackChunkName: "Login" */'@/views/Login.vue')
      },
      {
        path: '/password/recovery',
        name: 'PasswordRecovery',
        meta: { title: 'Recuperar Contraseña' },
        component: () => import(/* webpackChunkName: "PasswordRecovery" */'@/views/PasswordRecovery.vue')
      }
    ]
  }
];

export const protectedRoute = [
  {
    path: "/dashboard",
    component: DefaultLayout,
    meta: {      
      requiresAuth: true
    },
    children: [
      {    
        path: '',
        name: 'Dashboard',
        meta: {
          title: 'Dashboard',          
        },
        component: () => import(/* webpackChunkName: "Dashboard" */'@/views/Dashboard.vue') 
      },
    ]
  },
  {
    path: '/admin',
    component: DefaultLayout,
    meta: { requiresAuth: true },
    children: [
      {
        path: 'clients',
        meta: {
          title: 'Administración - Clientes'
        },
        component: () => import(/* webpackChunkName: "Clients" */'@/views/admin/Clients.vue')
      },
      {
        path: 'users',
        meta: {
          title: 'Administración - Usuarios'
        },
        component: () => import(/* webpackChunkName: "Users" */'@/views/admin/Users.vue')
      },
      {
        path: 'roles',
        meta: {
          title: 'Administración - Roles y Permisos'
        },
        component: () => import(/* webpackChunkName: "Roles" */'@/views/admin/Roles.vue')
      },
      {
        path: 'professional-insurances',
        meta: {
          title: 'Administración - AFP'
        },
        component: () => import(/* webpackChunkName: "ProfessionalInsurances" */'@/views/admin/ProfessionalInsurances.vue')
      },
      {
        path: 'job-titles',
        meta: {
          title: 'Administración - Cargos'
        },
        component: () => import(/* webpackChunkName: "JobTitles" */'@/views/admin/JobTitles.vue')
      },
      {
        path: 'health-insurances',
        meta: {
          title: 'Administración - EPS'
        },
        component: () => import(/* webpackChunkName: "HealthInsurances" */'@/views/admin/HealthInsurances.vue')
      },
      {
        path: 'contract-types',
        meta: {
          title: 'Administración - Tipos de Contrato'
        },
        component: () => import(/* webpackChunkName: "ContracTypes" */'@/views/admin/ContracTypes.vue')
      },
      {
        path: 'document-types',
        meta: {
          title: 'Administración - Tipos de Documento'
        },
        component: () => import(/* webpackChunkName: "DocumentTypes" */'@/views/admin/DocumentTypes.vue')
      },
      {
          path: 'settings',
          meta: {
              title: 'Administración - Configuración'
          },
          component: () => import(/* webpackChunkName: "Settings" */'@/views/admin/Settings.vue')
      },
      {
        path: 'daily-letters-references',
        meta: {
          title: 'Administración - Referencias Cartas Diarias'
        },
        component: () => import(/* webpackChunkName: "DailyLettersReferences" */'@/views/admin/DailyLettersReferences.vue')
      },
      {
        path: 'daily-letters-reasons',
        meta: {
          title: 'Administración - Razones Cartas Diarias'
        },
        component: () => import(/* webpackChunkName: "DailyLettersReasons" */'@/views/admin/DailyLettersReasons.vue')
      },
      {
        path: 'daily-letters-absent-genders',
        meta: {
          title: 'Administración - Géneros Ausentes Cartas Diarias'
        },
        component: () => import(/* webpackChunkName: "DailyLettersAbsentGenders" */'@/views/admin/DailyLettersAbsentGenders.vue')
      },
      {
        path: 'products',
        meta: {
          title: 'Stock - Productos'
        },
        component: () => import(/* webpackChunkName: "Products" */'@/views/admin/Products.vue')
      },
      {
        path: 'client-stock',
        meta: {
          title: 'Stock - Presupuestos'
        },
        component: () => import(/* webpackChunkName: "ClientStock" */'@/views/admin/ClientStock.vue')
      },
    ]
  },
  {
    path: '/client',
    component: DefaultLayout,
    meta: { requiresAuth: true },
    children: [
      {
        path: 'employees',
        meta: {
          title: 'Cliente - Empleados'
        },
        component: () => import(/* webpackChunkName: "Employees" */'@/views/client/Employees.vue')
      },
      {
        path: 'fiscal-auditor-documents',
        meta: {
          title: 'Cliente - Documentos Revisor Fiscal'
        },
        component: () => import(/* webpackChunkName: "FiscalAuditorDocuments" */'@/views/client/FiscalAuditorDocuments.vue')
      },
    ]
    
  },
  {
    path: '/accounting',
    component: DefaultLayout,
    meta: { requiresAuth: true },
    children: [
        {
            path: 'payroll-generation',
            meta: {
                title: 'Contabilidad - Generación Nómina'
            },
            component: () => import(/* webpackChunkName: "PayrollGeneration" */'@/views/accounting/PayrollGeneration.vue')
        },
      {
        path: 'payrolls',
        meta: {
          title: 'Contabilidad - Nómina'
        },
        component: () => import(/* webpackChunkName: "Payrolls" */'@/views/accounting/Payrolls.vue')
      },
      {
        path: 'work-incomes',
        meta: {
          title: 'Contabilidad - Ingresos y Retenciones'
        },
        component: () => import(/* webpackChunkName: "WorkIncomes" */'@/views/accounting/WorkIncomes.vue')
      },
      {
        path: 'fiscal-auditor-documents',
        meta: {
          title: 'Contabilidad - Documentos Revisor Fiscal'
        },
        component: () => import(/* webpackChunkName: "FiscalAuditorDocuments" */'@/views/accounting/FiscalAuditorDocuments.vue')
      },
      {
        path: 'loggro',
        meta: {
          title: 'Contabilidad - Generación Loggro'
        },
        component: () => import(/* webpackChunkName: "Loggro" */'@/views/accounting/Loggro.vue')
      },
      {
        path: 'notes',
        meta: {
          title: 'Contabilidad - Observaciones'
        },
        component: () => import(/* webpackChunkName: "AccountingNotes" */'@/views/accounting/AccountingNotes.vue')
      },
    ]
  },
  {
    path: '/hr',
    component: DefaultLayout,
    meta: { requiresAuth: true },
    children: [
      {
        path: 'events',
        meta: {
          title: 'RR.HH. - Novedades'
        },
        component: () => import(/* webpackChunkName: "HrEvents" */'@/views/hr_events/HrEvents.vue')
      },
      {
        path: 'daily-letters',
        meta: {
          title: 'RR.HH. - Cartas Díarias'
        },
        component: () => import(/* webpackChunkName: "DailyLetters" */'@/views/daily_letters/DailyLetters.vue')
      },
    ]
  },
  {
    path: '/pila',
    component: DefaultLayout,
    meta: { requiresAuth: true },
    children: [
      {
        path: 'reports',
        meta: {
          title: 'PILA - Reportes'
        },
        component: () => import(/* webpackChunkName: "PILA" */'@/views/pila/Pila.vue')
      },
    ]
  },
  {
    path: '/stock',
    component: DefaultLayout,
    meta: { requiresAuth: true },
    children: [
      {
        path: 'orders',
        meta: {
          title: 'Stock - Pedidos'
        },
        component: () => import(/* webpackChunkName: "StockOrders" */'@/views/stock/Orders.vue')
      },
      {
        path: 'purchase-orders',
        meta: {
          title: 'Stock - Órdenes de Pedido'
        },
        component: () => import(/* webpackChunkName: "StockPurchaseOrders" */'@/views/stock/PurchaseOrders.vue')
      },
      {
        path: 'tasks',
        meta: {
          title: 'Stock - Tareas'
        },
        component: () => import(/* webpackChunkName: "StockTasks" */'@/views/stock/Tasks.vue')
      },
      {
        path: 'reports',
        meta: {
          title: 'Stock - Reportes'
        },
        component: () => import(/* webpackChunkName: "StockReports" */'@/views/stock/Reports.vue')
      },
    ]
  },
  {
    path: '/certificates',
    component: DefaultLayout,
    meta: { requiresAuth: true },
    children: [
      {
        path: 'labor',        
        meta: {
          title: 'Comprobantes y Certificados - Certificado Laboral'
        },
        component: () => import(/* webpackChunkName: "Roles" */'@/views/certificates/LaborCertificate.vue')
      },
      {
        path: 'pila',        
        meta: {
          title: 'Comprobantes y Certificados -  PILA'
        },
        component: () => import(/* webpackChunkName: "Roles" */'@/views/certificates/PilaCertificate.vue')
      },
      {
        path: 'payroll',        
        meta: {
          title: 'Comprobantes y Certificados - Comprobante de pago'
        },
        component: () => import(/* webpackChunkName: "Roles" */'@/views/certificates/PayrollCertificate.vue')
      },
      {
        path: 'work-income',
        meta: {
          title: 'Comprobantes y Certificados - Ingresos y Retenciones'
        },
        component: () => import(/* webpackChunkName: "WorkIncome" */'@/views/certificates/WorkIncomeCertificate.vue')
      },
    ]
  }
];





